import { render, staticRenderFns } from "./underwriting.vue?vue&type=template&id=4cdb1e9a&scoped=true&"
import script from "./underwriting.vue?vue&type=script&lang=js&"
export * from "./underwriting.vue?vue&type=script&lang=js&"
import style0 from "./underwriting.vue?vue&type=style&index=0&id=4cdb1e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdb1e9a",
  null
  
)

export default component.exports